import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20;

import { css } from 'styled-components';
import { getButtonContentElementsColor } from "../../shared-styles";
import { focusOutlinesStyles, getHexToRgb } from "./../../../core";
var lightBackgroundStateColorStyles = {
  gray: {
    active: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (_ref) {
      var theme = _ref.theme;
      return theme.color.state.dark.pressed.value;
    }),
    "default": css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n    "])), function (_ref2) {
      var theme = _ref2.theme;
      return getButtonContentElementsColor(theme.color.text.light.secondary.value);
    }),
    disabled: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", ";\n    "])), function (_ref3) {
      var theme = _ref3.theme;
      return getButtonContentElementsColor(theme.color.text.light.disabled.value);
    }),
    focus: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", ";\n    "])), function (_ref4) {
      var theme = _ref4.theme;
      return theme.color.state["default"].focus.value;
    }, focusOutlinesStyles.dark),
    hover: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (_ref5) {
      var theme = _ref5.theme;
      return theme.color.state["default"].hover.value;
    })
  },
  primary: {
    active: css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", "\n    "])), function (_ref6) {
      var theme = _ref6.theme;
      return theme.color.state.primary.pressed.value;
    }, function (_ref7) {
      var theme = _ref7.theme;
      return getButtonContentElementsColor(theme.color.primary[700].value);
    }),
    "default": css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      ", "\n    "])), function (_ref8) {
      var theme = _ref8.theme;
      return getButtonContentElementsColor(theme.color.primary[500].value);
    }),
    disabled: css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      ", ";\n    "])), function (_ref9) {
      var theme = _ref9.theme;
      return getButtonContentElementsColor(theme.color.text.light.disabled.value);
    }),
    focus: css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", "\n      ", ";\n    "])), function (_ref10) {
      var theme = _ref10.theme;
      return theme.color.state.primary.focus.value;
    }, function (_ref11) {
      var theme = _ref11.theme;
      return getButtonContentElementsColor(theme.color.primary[600].value);
    }, focusOutlinesStyles.primary),
    hover: css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", ";\n    "])), function (_ref12) {
      var theme = _ref12.theme;
      return theme.color.state.primary.hover.value;
    }, function (_ref13) {
      var theme = _ref13.theme;
      return getButtonContentElementsColor(theme.color.primary[600].value);
    })
  }
};
var primaryBackgroundStateColorStyles = {
  active: css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), function (_ref14) {
    var theme = _ref14.theme;
    return "rgba(".concat(getHexToRgb(theme.color.additional.dark.value), ", 0.3)");
  }),
  "default": css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref15) {
    var theme = _ref15.theme;
    return getButtonContentElementsColor(theme.color.additional.light.value);
  }),
  disabled: css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref16) {
    var theme = _ref16.theme;
    return getButtonContentElementsColor("rgba(".concat(getHexToRgb(theme.color.additional.light.value), ", 0.4)"));
  }),
  focus: css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    ", ";\n  "])), function (_ref17) {
    var theme = _ref17.theme;
    return "rgba(".concat(getHexToRgb(theme.color.additional.dark.value), ", 0.2)");
  }, focusOutlinesStyles.light),
  hover: css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), function (_ref18) {
    var theme = _ref18.theme;
    return "rgba(".concat(getHexToRgb(theme.color.additional.dark.value), ", 0.2)");
  })
};
var darkBackgroundStateColorStyles = {
  active: css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    ", ";\n  "])), function (_ref19) {
    var theme = _ref19.theme;
    return theme.color.state.light.pressed.value;
  }, function (_ref20) {
    var theme = _ref20.theme;
    return getButtonContentElementsColor(theme.color.additional.light.value);
  }),
  "default": css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref21) {
    var theme = _ref21.theme;
    return getButtonContentElementsColor(theme.color.text.dark.secondary.value);
  }),
  disabled: css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref22) {
    var theme = _ref22.theme;
    return getButtonContentElementsColor("rgba(".concat(getHexToRgb(theme.color.additional.light.value), ", 0.4)"));
  }),
  focus: css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    ", ";\n    ", ";\n  "])), function (_ref23) {
    var theme = _ref23.theme;
    return "rgba(".concat(getHexToRgb(theme.color.additional.light.value), ", 0.15)");
  }, function (_ref24) {
    var theme = _ref24.theme;
    return getButtonContentElementsColor(theme.color.additional.light.value);
  }, focusOutlinesStyles.light),
  hover: css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    ", ";\n  "])), function (_ref25) {
    var theme = _ref25.theme;
    return "rgba(".concat(getHexToRgb(theme.color.additional.light.value), ", 0.15)");
  }, function (_ref26) {
    var theme = _ref26.theme;
    return getButtonContentElementsColor(theme.color.additional.light.value);
  })
}; // It was decided to use gray button styling only
// but allow to cover primary color styling in cases we do not know

var iconButtonStateStyles = {
  dark: {
    gray: darkBackgroundStateColorStyles,
    primary: primaryBackgroundStateColorStyles
  },
  light: lightBackgroundStateColorStyles,
  primary: {
    gray: primaryBackgroundStateColorStyles,
    primary: primaryBackgroundStateColorStyles
  }
};
export var getStateStyles = function getStateStyles(backgroundAppearance, iconColor) {
  return iconButtonStateStyles[backgroundAppearance][iconColor];
};